import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  title: string;
  constructor() { }

  ngOnInit() {
    this.title = "Dashboard";
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/dashboard/dashboard.component.ts